<template>
  <div class="template-cases">
    <div class="caselist-container">
      <case-list
        class="case-list"
        :user="user"
        :data="cases"
        :org-data="orgData"
        :get-user-pref="makeGetUserPref()"
        :set-user-pref="() => {}"
        :show-search="false"
        :show-filters="false"
        :show-favorites="false"
        :show-column-editor="false"
        :previewed-case="selectedCase"
        @previewCase="caseConf => selectCase(caseConf)"
        @sort="field => sort(field)"
      />
    </div>
    <case-preview
      v-if="selectedCase"
      class="case-preview"
      :case-conf="selectedCase"
      :user="user"
      :show-favorite="false"
    >
      <template slot="actions">
        <md-button
          v-if="!isPublished(selectedCase)"
          class="md-raised md-primary"
          @click="publish()"
        >
          Add To Templates
          <md-tooltip md-direction="top" md-delay="300">Add this case to the list of template cases</md-tooltip>
        </md-button>
        <md-button
          v-if="isPublished(selectedCase)"
          class="md-raised md-primary"
          @click="unpublish()"
        >
          Remove From Templates
          <md-tooltip
            md-direction="top"
            md-delay="300"
          >
            Remove this case from the list of template cases
          </md-tooltip>
        </md-button>
        <md-button
          v-if="appLabAvailable && !hasAppLabAccess(selectedCase, productType)"
          class="md-raised md-primary"
          @click="addAppLabAccess()"
        >
          Make Available To App Lab Users
          <md-tooltip md-direction="top" md-delay="300">
            Make the case available to all App Lab users
          </md-tooltip>
        </md-button>
        <md-button
          v-if="appLabAvailable && hasAppLabAccess(selectedCase, productType)"
          class="md-raised md-primary"
          @click="removeAppLabAccess()"
        >
          Remove From All App Lab Users
          <md-tooltip md-direction="top" md-delay="300">
            Make the case no longer availble to App Lab users
          </md-tooltip>
        </md-button>
      </template>
    </case-preview>
  </div>
</template>

<script>
import keyBy from 'lodash/keyBy';

import CaseList from '~lib/common/components/CaseList/CaseList.vue';
import CasePreview from '~lib/common/components/CasePreview';
import { isPublished, hasAppLabAccess } from '~lib/common/utils/publish';
import { hasAppLab } from '~lib/common/config/appLabOrg';

export default {
  name: 'template-cases',
  components: {
    CaseList,
    CasePreview,
  },
  props: {
    cases: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    },
    updating: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Object,
      default: null
    },
    user: {
      type: Object,
      required: true
    },
    orgData: {
      type: Object,
      default: () => {},
    },
    productType: {
      type: String,
      default: 'EMS',
    },
  },
  data() {
    return {
      state: {
        selectedCaseId: null
      }
    };
  },
  computed: {
    casesById() {
      return keyBy(this.cases, 'id');
    },
    selectedCase() {
      return this.casesById[this.state.selectedCaseId];
    },
    appLabAvailable() {
      return hasAppLab(this.productType);
    },
  },
  watch: {},
  methods: {
    selectCase(caseConf) {
      this.state.selectedCaseId = caseConf.id;
    },
    publish() {
      this.$emit('publish', this.selectedCase);
    },
    unpublish() {
      this.$emit('unpublish', this.selectedCase);
    },
    addAppLabAccess() {
      this.$emit('addAppLabAccess', this.selectedCase);
    },
    removeAppLabAccess() {
      this.$emit('removeAppLabAccess', this.selectedCase);
    },
    sort(field) {
      this.$emit('sort', field);
    },
    makeGetUserPref() {
      return () => {
        let columns = ['_avatar', 'published']
        if (this.appLabAvailable) {
          columns = columns.concat('applab');
        }
        return columns;
      };
    },
    isPublished,
    hasAppLabAccess,
    hasAppLab,
  }
};
</script>

<style scoped>
.template-cases {
  height: 100%;
  display: flex;
}

.caselist-container {
  flex: 2;
  min-width: 700px;
  min-height: 300px;
}

.case-preview {
  flex: 1;
  min-width: 500px;
  padding: 0 15px 10px 35px;
}

.error {
  color: red;
}

.menu {
  height: 60px;
  display: flex;
  align-items: center;
  font-weight: 500;
  font-size: 18px;
  text-align: left;
  border-bottom: 1px solid #2b2b2b;
}
.menu-name {
  flex: 2.4;
  margin-left: 20px;
}

.menu-patient {
  flex: 0.7;
}
.menu-scene {
  flex: 0.9;
}
.menu-published {
  flex: 0.7;
  margin-right: 24px;
}
.menu-applab-access {
  flex: 0.7;
}
.menu-scene {
  width: 10%;
}
.column-published {
  flex: 0.5 1 auto;
}
.column-applab-access {
  flex: 0.5 1 auto;
}
.md-checkbox.md-checked.column-applab-access >>> .md-checkbox-container {
  background-color: #009688;
  border-color: #009688;
}
</style>